import { defineComponent as _defineComponent } from 'vue';
import Button from 'primevue/button';
import Menu from 'primevue/menu';
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'GroupActions',
    props: {
        groupActions: {
            type: Array,
            default: [],
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    setup(__props, { expose }) {
        expose();
        const props = __props;
        const groupActionsMenu = ref();
        const open = ref(false);
        const toggleGroupActionsMenu = (event) => {
            groupActionsMenu.value?.toggle(event);
        };
        const __returned__ = { props, groupActionsMenu, open, toggleGroupActionsMenu, get Button() { return Button; }, get Menu() { return Menu; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
